import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-flags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flags = _resolveComponent("flags")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_flags, {
      flags: _ctx.flags,
      limit: _ctx.limit,
      "award-limit": _ctx.awardLimit,
      "white-list": _ctx.whiteList && _ctx.whiteList.length > 0 ? _ctx.whiteList : _ctx.settings.flags.whitelist,
      "lazy-load": false,
      "enable-links": true,
      "target-blank-flags": _ctx.targetBlankFlags,
      "with-savings-max": _ctx.withSavingsMax,
      onClick: _ctx.clickHandler
    }, null, 8 /* PROPS */, ["flags", "limit", "award-limit", "white-list", "target-blank-flags", "with-savings-max", "onClick"])
  ]))
}